import React from 'react';
import { HomeAudiences } from '../components/home/HomeAudiences';
import { HomeConsultants } from '../components/home/HomeConsultants';
import { HomeHero } from '../components/home/HomeHero';
import { HomeIndustries } from '../components/home/HomeIndustries';
import { HomeInsights } from '../components/home/HomeInsights';
import { HomeIntro } from '../components/home/HomeIntro';
import { HomeProcess } from '../components/home/HomeProcess';
import { HomeServices } from '../components/home/HomeServices';
import { HomeWhy } from '../components/home/HomeWhy';
import { ButtonLink } from '../components/ui/ButtonLink';
import { CtaBand } from '../components/ui/CtaBand';
import { LeadershipSculpture } from '../components/three/LeadershipSculpture';
import { images } from '../data/images';
import { consultants } from '../data/consultants';
import { services } from '../data/services';
import { usePageMeta } from '../hooks/usePageMeta';
import { SITE_NAME } from '../utils/seo';
export function Home() {
  usePageMeta(SITE_NAME, 'Aurevane Search Partners is an executive search firm connecting organizations with exceptional leaders for C-suite, board, and senior leadership appointments, including confidential searches.', {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: SITE_NAME,
    description: 'Executive search, C-suite recruitment, board and non-executive director search, and leadership talent advisory.',
    url: typeof window !== 'undefined' ? window.location.origin : undefined,
    serviceType: services.map(s => s.title),
    employee: consultants.map(c => ({
      '@type': 'Person',
      name: c.name,
      jobTitle: c.title
    }))
  });
  return <>
      <HomeHero data-id="element-826" data-mp="23alwv010v2wm" />
      <HomeIntro data-id="element-827" data-mp="236y7md2m12np" />
      <HomeServices data-id="element-828" data-mp="1z7fu42d4btuw" />
      <HomeIndustries data-id="element-829" data-mp="1z7pbx2o0eupi" />
      <HomeProcess data-id="element-830" data-mp="1z64ixhhcfjtr" />
      <HomeWhy data-id="element-831" data-mp="1z6mk8siv4o8j" />
      <HomeConsultants data-id="element-832" data-mp="1z98rss5r73qr" />
      <HomeAudiences data-id="element-833" data-mp="1u7t7j2beh19f" />
      <HomeInsights data-id="element-834" data-mp="1u9e40xh9yu9x" />
      <CtaBand title="The Right Leadership Can Change Everything." text="Whether you are building your leadership team or considering your next executive opportunity, begin a conversation with Aurevane Search Partners." visual={<LeadershipSculpture fallbackSrc={images.heroFallback} data-id="element-836" data-mp="1amt1aym5gtp1" />} data-id="element-835" data-mp="1u8usbyi7x24c">
        <ButtonLink to="/contact" size="lg" data-id="element-837" data-mp="1aonji561e7pf">
          Contact Our Team
        </ButtonLink>
        <ButtonLink to="/consultants" variant="outline-light" size="lg" data-id="element-838" data-mp="1fnqgr3frz9mu">
          Meet Our Consultants
        </ButtonLink>
      </CtaBand>
    </>;
}